import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dc-box"
};
const _hoisted_2 = {
  class: "dc-header"
};
const _hoisted_3 = {
  class: "dc-title"
};
const _hoisted_4 = {
  class: "dc-body"
};
const _hoisted_5 = {
  class: "dc-footer"
};
import { onBeforeUnmount, onMounted } from 'vue';
import { CloseBold } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteConfirmDialog',
  props: {
    title: {
      default: '提示'
    },
    message: {
      default: ''
    },
    confirmButtonText: {
      default: '确定'
    },
    cancelButtonText: {
      default: '取消'
    }
  },
  emits: ["confirm", "cancel"],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    function onKeydown(e) {
      if (e.key === 'Escape') emits('cancel');
    }
    onMounted(() => document.addEventListener('keydown', onKeydown));
    onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown));
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", {
        class: "dc-mask",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => emits('cancel'), ["self"]))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1), _createVNode(_component_el_icon, {
        class: "dc-close",
        size: 16,
        onClick: _cache[0] || (_cache[0] = $event => emits('cancel'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.message), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        class: "dc-btn dc-btn--cancel",
        onClick: _cache[1] || (_cache[1] = $event => emits('cancel'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.cancelButtonText), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        class: "dc-btn dc-btn--confirm",
        onClick: _cache[2] || (_cache[2] = $event => emits('confirm'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmButtonText), 1)]),
        _: 1
      })])])]);
    };
  }
});